import styled from 'styled-components';
import { PropertyCardFlexWrapperMixin } from '../../mixins/components/PropertyCardFlexWrapperMixin';
export var StyledPropertyCardFlexWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPropertyCardFlexWrapper",
  componentId: "c11n-8-111-1__sc-38h0t9-0"
})(["", ""], PropertyCardFlexWrapperMixin);